export default __webpack_public_path__ + "static/media/slide01-1.7ffe1cae.jpg";